import { createSlice } from '@reduxjs/toolkit'
import partsInBasket from '../../utils/constants/partsInBasket'
import _ from 'lodash'

let initialState = partsInBasket

export const partsInBasketSlice = createSlice({
    name: 'partsInBasket',
    initialState,
    reducers: {
        setParts: (state, action) => action.payload,
        addPartInBasketQuantity: (state, action) => {
            if (_.has(state, [action.payload.hash])) {
                state[action.payload.hash]['quantity'] += action.payload.quantity
            } else {
                state[action.payload.hash] = {
                    basket_id: 100500,
                    quantity: action.payload.quantity
                }
            }
        },
        setPartInBasketQuantity: (state, action) => {
            if (action.payload.quantity <= 0) {
                delete state[action.payload.hash]
            } else {
                state[action.payload.hash]['quantity'] = action.payload.quantity
            }
        }
    }
})

export const { setParts, setPartInBasketQuantity, addPartInBasketQuantity } =
    partsInBasketSlice.actions

export const selectPartsInBasket = (state) => state.partsInBasket

export default partsInBasketSlice.reducer
